import { Form, Table } from "react-bootstrap";
import { useState } from "react";
import AddOrder from "./AddOrder";
import UpdateOrder from "./UpdateOrder";
import Moment from "react-moment";
import { useEffect } from "react";
import Swal from "sweetalert2";
import UseToggle from "../../../../../Hooks/UseToggle";
import { storeOrderServices } from "../../../../../APIServices/SitePilotManagement/StoreManagement/storeOrderServices";
import ToolBar from "../../../../Componant/ToolBar";

const OrderManagement = () => {
  const toggles = UseToggle();
  const [search, setSearch] = useState("");
  const [loader, setLoader] = useState(false);
  const [storeCategories, setStoreCategories] = useState([]);
  const [storeOrderData, setStoreOrderData] = useState("");
  const [storeOrderCount, setStoreOrderCount] = useState(0);
  const [storeOrderIds, setStoreOrderIds] = useState([]);
  const [OrderData, setOrderData] = useState("");
  const [showPreview, setShowPreview] = useState(false);
  const [addNewProduct, setAddNewProduct] = useState(false);
  const [updateNewProduct, setUpdateNewProduct] = useState(false);

  const toggleSingle = (id) => {
    setStoreOrderIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
  };

  const toggleAll = () => {
    if (storeOrderIds.length === storeCategories.length) {
      setStoreOrderIds([]);
    } else {
      setStoreOrderIds(storeCategories.map((c) => c.id));
    }
  };

  const isAllChecked =
    storeCategories.length > 0 &&
    storeOrderIds.length === storeCategories.length;
  const isChecked = (id) => storeOrderIds.includes(id);

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const totalPages = Math.ceil(storeOrderCount / itemsPerPage);

  const start = (pageNumber - 1) * itemsPerPage + 1;
  const end = Math.min(pageNumber * itemsPerPage, storeOrderCount);

  const getStoreOrderList = async () => {
    setLoader(true);
    let data = await storeOrderServices.getStoreOrderList(
      "all",
      search,
      pageNumber,
      itemsPerPage,
    );
    setStoreCategories(data?.data || []);
    setStoreOrderCount(data?.count || 0);
    setLoader(false);
  };

  const updatedStoreOrder = async (OrderId, status) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to ${status} this Store Order?`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${status} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.OrderId = OrderId;
        userData.status = status;
        userData.settings = "status";
        let data = await storeOrderServices.updatedStoreOrder(userData);
        if (data?.statusCode === 200) {
          getStoreOrderList();
        }
      }
    });
  };

  const deleteStoreOrder = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this Store Order?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.OrderIds = storeOrderIds;
        let data = await storeOrderServices.deleteStoreOrder(userData);
        if (data?.statusCode === 200) {
          getStoreOrderList();
        }
      }
    });
  };

  useEffect(() => {
    let storeOrderData = storeCategories?.find(
      (item) => item.OrderId === storeOrderIds?.[0],
    );
    setStoreOrderData(storeOrderData || "");
  }, [storeOrderIds]);

  useEffect(() => {
    getStoreOrderList();
  }, [search, pageNumber, itemsPerPage]);

  return (
    <>
      {addNewProduct ? (
        <AddOrder
          setAddNewProduct={setAddNewProduct}
          getStoreOrderList={getStoreOrderList}
        />
      ) : updateNewProduct ? (
        <UpdateOrder
          setUpdateNewProduct={setUpdateNewProduct}
          getStoreOrderList={getStoreOrderList}
        />
      ) : (
        <>
          <ToolBar
            toggles={toggles}
            search={search}
            setSearch={setSearch}
            checkedIds={storeOrderIds}
            setCheckedIds={setStoreOrderIds}
            showPreview={showPreview}
            setShowPreview={setShowPreview}
            setSelected={setOrderData}
            start={start}
            end={end}
            totalItems={storeOrderCount}
            page={pageNumber}
            setPage={setPageNumber}
            setPageSize={setItemsPerPage}
            pageSize={itemsPerPage}
            totalPages={totalPages}
            setAddNewProduct={setAddNewProduct}
            setUpdateNewProduct={setUpdateNewProduct}
            addNewProduct
            deleteData
            updateNewProduct
            editField
          />
          <div className={`contacts-layout ${showPreview ? "with-preview" : ""}`}>
            <div
              className={`table-section overflow-auto bg-white ${showPreview ? "border-end" : ""}`}
              style={{ height: "calc(100vh - 106px)" }}
            >
              <Table
                hover
                className="contacts-table mb-0"
                style={{ verticalAlign: "middle" }}
              >
                <thead>
                  <tr>
                    <th style={{ width: "30%" }}>
                      <div className="d-flex align-items-center gap-2">
                        <div className="px-2">
                          <Form.Check
                            type="checkbox"
                            checked={isAllChecked}
                            onChange={toggleAll}
                            onClick={(e) => e.stopPropagation()}
                          />
                        </div>
                        <div>Order No.</div>
                      </div>
                    </th>
                    <th>Customer</th>
                    {!OrderData && (
                      <>
                        <th>Status</th>
                        <th>Total Item</th>
                        <th>Total Price</th>
                        <th>Billing Country</th>
                        <th>Action</th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {storeCategories?.map((item) => (
                    <tr
                      key={item.OrderId}
                      className={`contact-row ${OrderData?.OrderId === item.OrderId ? "active" : ""}`}
                      onClick={() => {
                        setOrderData(item);
                        setShowPreview(true);
                      }}
                    >
                      <td
                        className="text-truncate text-wrap"
                        style={{ maxWidth: 100 }}
                      >
                        <div className="d-flex align-items-center gap-2">
                          <div className="px-2">
                            <Form.Check
                              type="checkbox"
                              checked={isChecked(item.OrderId)}
                              onChange={() => toggleSingle(item.OrderId)}
                              onClick={(e) => e.stopPropagation()}
                            />
                          </div>
                          <div>
                            <div className="fw-medium">{item.name}</div>
                            <small className="text-muted">
                              {item.description}
                            </small>
                          </div>
                        </div>
                      </td>
                      {!OrderData && (
                        <>
                          <td>
                            <Form.Check
                              type="switch"
                              onChange={() =>
                                updatedStoreOrder(
                                  item?.OrderId,
                                  item.status === "active"
                                    ? "inactive"
                                    : "active",
                                )
                              }
                              checked={item.status === "active"}
                            />
                          </td>
                          <td>
                            <span className="fw-medium">
                              <Moment format="DD MMM YYYY | HH:mm" withTitle>
                                {item?.createdAt}
                              </Moment>
                            </span>
                          </td>
                          <td>
                            <span className="fw-medium">
                              <Moment format="DD MMM YYYY | HH:mm" withTitle>
                                {item?.updatedAt}
                              </Moment>
                            </span>
                          </td>
                        </>
                      )}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            <div className={`preview-section ${showPreview ? "open" : ""}`}>
              {OrderData && (
                <div
                  className="overflow-auto"
                  style={{ height: "calc(100vh - 108px)" }}
                >
                  <div className="preview-scroll p-0">
                    <div className="preview-block">
                      <OrderData
                        OrderData={OrderData}
                        getStoreOrderList={getStoreOrderList}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default OrderManagement;
